interface MaxReachedPower {
  value?: unknown
  date?: unknown
}

// Read in UTC: `new Date('YYYY-MM-DD')` is UTC midnight and shows the previous month west of Greenwich.
const formatMonth = (isoDate: unknown, locale?: string): string | null => {
  if (typeof isoDate !== 'string') return null
  const date = new Date(`${isoDate.slice(0, 10)}T00:00:00Z`)
  if (Number.isNaN(date.getTime())) return null

  return date.toLocaleDateString(locale, { month: 'long', year: 'numeric', timeZone: 'UTC' })
}

export const formatMaxReachedPower = ({ value, date }: MaxReachedPower, locale?: string): string | null => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null

  const power = `${value.toLocaleString(locale, { maximumFractionDigits: 1 })} kVA`
  const month = formatMonth(date, locale)

  return month ? `${power} (${month})` : power
}
